jQuery(document).ready(function($) {

    // Array.indexOf polyfill (for IE8)
    // ================================
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function(elt /*, from*/) {
            var len = this.length >>> 0;

            var from = Number(arguments[1]) || 0;
            from = (from < 0)
              ? Math.ceil(from)
              : Math.floor(from);

            if (from < 0)
                from += len;

            for (; from < len; from++) {
                if (from in this && this[from] === elt)
                    return from;
            }
            return -1;
        };
    }

    // False func for stopping events
    // ==============================
    function _false() {
        return false;
    }

    // Smart (debounced) resize
    // ========================
    // source: http://www.paulirish.com/2009/throttled-smartresize-jquery-event-handler/

    (function($,sr) {

      // debouncing function from John Hann
      // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
      var debounce = function (func, threshold, execAsap) {
          var timeout;

          return function debounced () {
              var obj = this, args = arguments;
              function delayed () {
                  if (!execAsap)
                      func.apply(obj, args);
                  timeout = null;
              }

              if (timeout)
                  clearTimeout(timeout);
              else if (execAsap)
                  func.apply(obj, args);

              timeout = setTimeout(delayed, threshold || 100);
          };
      };
      // smartresize
      jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

    })(jQuery,'smartresize');

    // Breakpoint Watcher
    // ==================
    // deps: smartresize

    (function($){

        window.getBpWatcher = function getBpWatcher( args ) {
            // TODO: modify to accept init arguments
            if ( window.breakpointWatcher == undefined ) {
                window.breakpointWatcher = new BpWatcher(args);
            }

            return window.breakpointWatcher;
        };

        window.BpWatcher = function BpWatcher( args ) {

            // force instance
            if ( ! (this instanceof BpWatcher) ) {
                return window.getBpWatcher(args);
            }

            // apply defaults
            this.opts = $.extend({}, this.defaults, ( typeof opts === 'object' ? opts : {} ) );

            // init instance vars
            this.elems     = [];
            this.stateObjs = [];

            // generate bpArr and bpMap lookups
            this._generateBpMaps();

            // grab window
            this.$window = $(window);

            // trigger initial 'watch' event
            this._watch();

            // listen to window (smart)resize event
            this.$window.smartresize( this._watch.bind(this) );

        };

        window.BpWatcher.prototype = {
            construct: window.BpWatcher,
            defaults: {
                rootNamespace: 'bpw',
                breakpoints: {
                    xs: 0,
                    sm: 768,
                    md: 992,
                    lg: 1200,
                },
            },
            // Primary event listener
            // ----------------------
            _watch: function(e) {

                // get current breakpoint
                var curBreakpoint = this._checkBreakpoint();

                if ( curBreakpoint != this.curBreakpoint ) {

                    // set prev/cur breakpoint(s)
                    this.prevBreakpoint = this.curBreakpoint;
                    this.curBreakpoint  = curBreakpoint;
                    // trigger events
                    this.triggerEvents( 'all' );

                }

            },
            // API
            // ---
            add: function( $el, namespaces ) {
                var stateObj, _namespaces;
                // TODO: validate args
                // check namespaces
                if ( !namespaces ) {
                    throw new Error('BpMatcher: missing argument "namespaces", implicit namespaces not implemented yet');
                }

                // get/create state object for $el
                stateObj = this._getStateObj($el, true);

                // normalize namespaces argument into namespace objects
                _namespaces = this._normalizeNamespaces( namespaces );

                // fetch rules from DOM where applicable
                _namespaces = this._computeRules( $el, _namespaces );

                // add namespaces to state obj
                this._addNamespaces( stateObj, _namespaces );

            },
            remove: function( $el, namespaces ) {

                switch ( namespaces == undefined ) {
                    case true:
                        // remove entire stateobj
                        var idx = this._findStateObj( $el, 'index' );
                        if ( idx != -1 ) {
                            this.stateObjs = this.stateObjs.splice(idx, 1);
                        }
                        break;
                    case false:
                        namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces;
                        // remove namespace from obj
                        var obj = this._findStateObj( $el, 'object' );
                        if ( typeof obj === 'object' ) {
                            namespaces.forEach(function(namespace) {
                                delete obj[namespace];
                            });
                        }
                        break;
                }
                // TODO: handle ability to remove $els and/or namespaces
            },
            triggerEvents: function( which, curBp ) {

                which = which == undefined ? 'all' : which;
                curBp = curBp == undefined ? this.curBreakpoint : curBp;

                if ( which === 'all' || which === 'window' || which == this.$window || which == window ) {
                    // trigger window change event
                    this.$window.trigger(
                        this.opts.rootNamespace+'.change',
                        {
                            from: this.bpMap[ this.prevBreakpoint ],
                            to: this.bpMap[ curBp ],
                        }
                    );
                }

                if ( which === 'all' || which === 'elems' ) {
                    // loop over registered elems and check their state && call on/off events
                    this.stateObjs.forEach( this._triggerObjEvents.bind(this) );
                }

                if ( which instanceof jQuery ) {
                    var stateObj = this._findStateObj( which );
                    if ( stateObj ) {
                        this._triggerObjEvents( stateObj, true );
                    }
                }

            },
            _triggerObjEvents: function( stateObj, force ) {

                for ( var namespace in stateObj.namespaces ) {
                    var rules     = stateObj.namespaces[ namespace ],
                        prevState = this.prevBreakpoint != undefined ? rules[ this.prevBreakpoint ] : null,
                        curState  = rules[ this.curBreakpoint ],
                        stateStr  = curState ? 'on' : 'off';

                    if ( prevState === null || prevState != curState || force ) {
                        stateObj.$el.trigger(this.opts.rootNamespace+'.'+namespace+'.'+stateStr);
                        stateObj.$el.trigger(this.opts.rootNamespace+'.'+namespace+'.change', stateStr);
                    }
                }

            },
            // State Objects
            // -------------
            _getStateObj: function( $el, create ) {
                var stateObj;
                switch ( this.elems.indexOf($el) === -1 ) {
                    case true:
                        // elem not previously bound, create new state obj
                        if ( !create )
                            return false;

                        stateObj = {
                            $el: $el,
                        };
                        this.stateObjs.push(stateObj);
                        // push to elems array for lookup
                        this.elems.push($el);
                        break;
                    case false:
                        // fetch existing state object
                        stateObj = this._findStateObj( $el );
                        break;
                }
                return stateObj;
            },
            _findStateObj: function( $el, ret ) {
                ret = ret == undefined ? 'object' : ret;

                var stateObj,
                    idx = -1;

                if ( !$el ) return false;

                for ( var i = 0; i < this.stateObjs.length; i++ ) {
                    var _stateObj = this.stateObjs[i];

                    if ( _stateObj.$el == $el ) {
                        stateObj = _stateObj;
                        idx = i;
                        break;
                    }

                }

                switch ( ret ) {
                    case 'idx':
                    case 'index':
                        return idx;
                    default:
                    case 'obj':
                    case 'object':
                        return stateObj;
                }

            },
            // Namespaces / Rules
            // ------------------
            _normalizeNamespaces: function( namespaces ) {
                // normalizes namespace argument into singular format
                var _namespaces = {};

                // is string
                if ( typeof namespaces == 'string' ) {
                    namespaces = [ namespaces ];
                }

                switch (true) {
                    case ( Array.isArray(namespaces) ):
                        // is array
                        namespaces.forEach(function(namespace) {
                            _namespaces[ namespace ] = null;
                        });
                        break;
                    case ( namespaces != null && typeof namespaces == 'object' ):
                        // is key:value obj
                        _namespaces = $.extend({}, namespaces);
                        break;
                }

                return _namespaces;

            },
            _emptyRuleObj: function() {
                var obj = {};
                for ( var bp in this.bpMap ) {
                    obj[ bp ] = false;
                }
                return obj;
            },
            _computeRules: function( $el, namespaces ) {
                var bpList = Object.keys( this.bpMap );
                for ( var namespace in namespaces ) {
                    var rules = namespaces[ namespace ];

                    // if is null, get string from DOM
                    if ( rules == null || rules == undefined ) {
                        rules = this._extractFromDom( $el, namespace );
                    }

                    if ( typeof rules == 'string' ) {
                        rules = rules.split(' ');
                    }
                    // if is string, convert to obj
                    switch ( true ) {
                        case ( Array.isArray(rules) ):
                            var applies = this._emptyRuleObj();

                            rules.forEach(function(rule) {
                                // construct rule array
                                var _rule = [];
                                switch ( rule.indexOf('-') != -1 ) {
                                    case true:
                                        _rule = rule.split('-');
                                        break;
                                    case false:
                                        _rule[0] = rule;
                                        _rule[1] = null;
                                        break;
                                }

                                // get index of current rule bp
                                var bpIdx = bpList.indexOf( _rule[0] );

                                if ( bpIdx != -1 ) {
                                    switch ( _rule[1] ) {
                                        case null:
                                            // only given index
                                            applies[ bpList[bpIdx] ] = true;
                                            break;
                                        case 'min':
                                            // applies for all bps where array index is higher
                                            for ( var i = bpIdx; i < bpList.length; i++ ) {
                                                applies[ bpList[i] ] = true;
                                            }
                                            break;
                                        case 'max':
                                            // less than or equal array indexes
                                            for ( var i = bpIdx; i >= 0; i-- ) {
                                                applies[ bpList[i] ] = true;
                                            }
                                            break;
                                    }
                                }
                            });
                            namespaces[ namespace ] = applies;
                            break;
                        case ( typeof rules == 'object' ):
                            console.log('TODO: add support for object input for rules!');
                            break;
                    }
                    return namespaces;

                }

            },
            _extractFromDom: function( $el, namespace ) {

                var nsRegex = new RegExp('^'+namespace+'-.*', 'g'),
                    classes = $el.attr('class'),
                    rules   = [];


                if ( classes.indexOf(namespace) == -1 ) {
                    // get settings from parent
                    var $parent = $el.closest('[class^="'+namespace+'-"], [class*=" '+namespace+'-"]');
                    classes = $parent.length ? $parent.attr('class') : null;
                }

                if ( classes ) {
                    classes = classes.split(' ');
                    classes.forEach(function(c) {
                        if ( nsRegex.test(c) )
                            rules.push( c.replace(namespace+'-', '') );
                    });

                }

                return rules;

            },
            _addNamespaces: function( stateObj, namespaces ) {
                // adds namespaces to stateobj
                var existing = stateObj.namespaces ? stateObj.namespaces : {};
                stateObj.namespaces = $.extend(existing, namespaces);
            },
            // Breakpoint checking
            // -------------------
            _checkBreakpoint: function() {

                var windowWidth   = this._viewport().width,
                    curBreakpoint = null;

                for ( var i = 0; i < this.bpArr.length; i++ ) {
                    var bp = this.bpArr[i];

                    if ( windowWidth >= bp.lowerLimit && windowWidth <= bp.upperLimit ) {
                        curBreakpoint = bp.key;
                        break;
                    }
                }

                return curBreakpoint;

            },
            // Helpers
            // -------
            _generateBpMaps: function() {

                var keys = Object.keys( this.opts.breakpoints ),
                    idx = 0;

                this.bpArr = [];
                this.bpMap = {};

                for ( var bpKey in this.opts.breakpoints ) {
                    var bpObj = {
                        key: bpKey,
                        // nextKey: idx == keys.length - 1 ? null : keys[ idx + 1 ],
                        lowerLimit: this.opts.breakpoints[ bpKey ],
                        upperLimit: idx == keys.length - 1 ? 99999 : this.opts.breakpoints[ keys[idx+1] ] - 1,
                    };
                    this.bpArr.push( bpObj );
                    this.bpMap[ bpKey ] = bpObj;
                    idx++;
                }

            },
            _viewport: function() {
                // gets viewport height and width
                // from: http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
                var e = window, a = 'inner';
                if (!('innerWidth' in window )) {
                    a = 'client';
                    e = document.documentElement || document.body;
                }
                return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
            },
        };

    })(jQuery);

    // Menu Awesome Handler
    // ====================
    // deps: jquery, smartresize, BpWatcher

    var MenuAwesomeHandler = function( opts ) {

        if ( ! (this instanceof MenuAwesomeHandler) ) {
            return new MenuAwesomeHandler(opts);
        }

        // select DOM elements
        this.$menus = $('.block-menu-awesome');

        if ( !this.$menus || !this.$menus.length ) {
            return false;
        }

        // calc top level menu offset 
        this._positionTopLevel();

        // calc submenu initial positions
        this._positionSubMenus();

        // bind event listeners
        this._bindEvents();

    };

    MenuAwesomeHandler.prototype = {
        constructor: MenuAwesomeHandler,
        // Event Handlers
        // --------------
        _bindEvents: function() {
            // re-calc dropdown classes on resize
            $(window).smartresize(this._positionSubMenus.bind(this));
            // reposition top level on resize
            $(window).smartresize(this._positionTopLevel.bind(this));

            // grab breakpoint watcher singleton
            this.bpWatch = window.getBpWatcher();
            // register events for mobile-view namespace
            this.bpWatch.add(this.$menus, 'mobile-view');
            // bind change event
            this.$menus.on('bpw.mobile-view.change', this._bindMobileEvents.bind(this) );
            // trigger initial call
            this.bpWatch.triggerEvents( this.$menus );

        },
        _bindMobileEvents: function(e, state) {
            var $dropdowns = $(e.currentTarget).find('[data-toggle=dropdown]');
            switch ( state ) {
                case 'on':
                    // remove _prevent function @ mobile-view
                    $dropdowns.off('click.dropdowns');
                    // add nested dropdowns click @ mobile-view
                    $dropdowns.on('click.dropdowns', this._clickNestedDropdown);
                    break;
                case 'off':
                    // prevent bootstrap open class adding on click @ desktop-view
                    $dropdowns.on('click.dropdowns', this._prevent);
                    // remove nested dropdowns click @ desktop-view
                    $dropdowns.off('click.nested-dropdowns');
                    break;
            }

        },
        _prevent: function(e) {
            // helper function for prevent event propagation
            e.preventDefault();
            e.stopPropagation();

            // navigate if a real link was clicked
            var $e = $(e.currentTarget);
            if( $e.closest('.block-menu-awesome').hasClass('dropdowns-link-through') ) {
                var href = $e.attr('href');
                if(href && href.length && href != 'http://#') {
                    window.location.href = href;
                }
            }
        },
        // Nested dropdowns fix
        // --------------------
        _clickNestedDropdown: function(e) {
            e.preventDefault();
            e.stopPropagation();

            var $e      = $(e.currentTarget),
                $parent = $e.closest('li'),
                isOpen  = $parent.hasClass('open');

            $parent.toggleClass('open', !isOpen);
            $e.attr('aria-expanded', function(index, attr) {
                return !isOpen;
            });
        },
        // Sub menu positioning
        // --------------------
        clearLeftClasses: function() {
            this.$menus.each(function(idx, menu) {
                var $pulled = $(menu).find('.pull-left');
                $pulled.removeClass('pull-left');
            });
        },
        _positionTopLevel: function() {

            var windowWidth = $(window).width();
            this.$menus.each(function(idx, menu) {
                var $topLvl = $(menu).find('.depth-0 + .dropdown-menu');
                $topLvl.each(function(idx, m) {

                    $(m).css('display','block');

                    $(m).css('margin-left', '');

                    var offsetRight = ($(m).offset().left + $(m).outerWidth()),
                        spill = windowWidth - offsetRight;

                    if (spill < 0) {
                        $(m).css('margin-left', (spill - 5)+'px');
                    }

                    $(m).css('display','');

                });
            });
        },
        _positionSubMenus: function() {

            this.clearLeftClasses();

            this.$menus.each(function(idx, menu) {

                var $subMenus = $(menu).find('.dropdown-menu'),
                    $subLi = $(menu).find('li.dropdown-submenu');

                $subMenus.css('display', 'block');

                $subLi.each(function(idx, li) {

                    var $li = $(li),
                        $subMenu = $li.children('.dropdown-menu'),
                        overflow = $(window).width() <= ( $subMenu.outerWidth() + $subMenu.offset().left );

                    if ( overflow ) {
                        $li.addClass('pull-left');
                    }

                });

                $subMenus.css('display', '');

            });
        },
    };

    // window.MenuAwesomeHandler = window.MenuAwesomeHandler === undefined ? MenuAwesomeHandler : window.MenuAwesomeHandler;
    window.mAwesomeHandler = new MenuAwesomeHandler();
});
